import noimage from "../assets/no_image/noimage.png";

export const noImgShapes = {
    noimage,
};
